import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserSessionService, userRoleInClient } from '@core/services/user-session';
import { UserRole } from 'jplus-design-system-angular';
import { filter, map, take } from 'rxjs';

export function hasRoleGuard(roles?: UserRole[]): CanActivateFn {
  return route => {
    const userSessionService = inject(UserSessionService);
    const router = inject(Router);

    return userSessionService.user$.pipe(
      filter(user => !!user),
      take(1),
      map(user => {
        const currentClient = route.params?.['client'] ?? route.parent?.params?.['client'];
        const roleInClient = userRoleInClient(currentClient, user);

        if (roleInClient && roles?.includes(roleInClient.role)) {
          return true;
        }

        return router.createUrlTree(['/access-denied']);
      })
    );
  };
}
